import LoginForm from "../components/forms/LoginForm";

export default function Login() {
  return (
    <div class="page">
      <div class="logo-container">
        <h1 style="cursor: default;">mia</h1>
      </div>
      <LoginForm></LoginForm>
    </div>
  );
}
